import { memberPersistedState } from '~/stores/memberPersistence';

/**
 * Pinia's persistence (stores/memberPersistence.ts). It runs straight after Pinia's own plugin and
 * ahead of every other: a store created before it is installed is never persisted.
 */
export default defineNuxtPlugin({
    name: 'member-persisted-state',
    enforce: 'pre',
    dependsOn: ['pinia'],
    setup(nuxtApp) {
        nuxtApp.$pinia.use(memberPersistedState());
    },
});
